import Vuex from 'vuex';
import {ToastModule} from '@/store/toast';
import {AppModule} from './app';
import {MenuModule} from './menu';
import {ModalModule} from './modal';
import {DataModule} from './data';
import {TestimonialModule} from './testimonial';
import {EventModule} from './event';
import {LocaleModule} from './locale';
import {TutorialModule} from './tutorial';
import {OutroModule} from "@/store/outro";

const store = new Vuex.Store({});
export const AppStore = new AppModule({store, name: "app"});
export const EventStore = new EventModule({store, name: "event"});
export const LocaleStore = new LocaleModule({store, name: "locale"});
export const DataStore = new DataModule({store, name: "data"});
export const TestimonialStore = new TestimonialModule({store, name: "testimonial"});
export const ToastStore = new ToastModule({store, name: "toast"});
export const MenuStore = new MenuModule({store, name: "menu"});
export const ModalStore = new ModalModule({store, name: "modal"});
export const TutorialStore = new TutorialModule({store, name: "tutorial"});
export const OutroStore = new OutroModule({store, name: "outro"});
export default store;
